/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { IconWrapper } from "@insite/mobius/Icon";
import { toasterProps as toasterPropsDefault } from "@insite/mobius/Toast/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import CheckCircleSolid from "@monsma/XDL/Icons/CheckCircleSolid";
import ExclamationTriangleSolid from "@monsma/XDL/Icons/ExclamationTriangleSolid";
import InfoCircleSolid from "@monsma/XDL/Icons/InfoCircleSolid";
import TimesCircleSolid from "@monsma/XDL/Icons/TimesCircleSolid";
import { xBaseTheme } from "@monsma/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        closeButtonProps: {
            color: "common.ui10",
            buttonType: "outline",
            shape: "rectangle",
            css: css`
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: 11px;
                border: 0;
                width: 13px;
                padding: 0;
                background: transparent;
            `,
            size: 13,
        },
        closeButtonIconProps: {
            // src: Close,
            size: 13,
            color: "common.ui10",
            css: css`
                pointer-events: none;
                line-height: 14px;
            `,
        },
        bodyTypographyProps: {
            size: "13px",
            lineHeight: "22px",
            forwardAs: "p",
            css: css`
                overflow-wrap: break-word;
                word-wrap: break-word;
                min-width: 0;
                text-align: left;
                padding-right: 10px;
            `,
        },
        iconSrcByMessage: {
            success: CheckCircleSolid,
            warning: ExclamationTriangleSolid,
            danger: TimesCircleSolid,
            info: InfoCircleSolid,
        },
        iconProps: {
            color: "text.inverse",
            size: 17,
            css: css`
                margin-right: 13px;
            `,
        },
        cssOverrides: {
            toast: css`
                background: ${({ messageType, theme }: any) => getContrastColor(messageType, theme)};
                border: 1px solid ${({ messageType, theme }: any) => resolveColor(messageType, theme)};
                opacity: 1;
                box-shadow: none;
                border-radius: 2px;

                svg {
                    &,
                    * {
                        fill: ${({ messageType }: any) => getColor(messageType)};
                    }
                }

                @media print {
                    display: none;
                }
            `,
            toastBody: css`
                ${IconWrapper as any} {
                    align-self: center;
                }
                & {
                    margin: 11px;
                    width: 100%;
                }
                overflow-wrap: break-word;
                word-wrap: break-word;
                min-width: 0;
            `,
        },
    },
    toasterProps: toasterPropsDefault,
} as xBaseTheme["toast"];
